/* PMP-236 B3 (Kaufpfad), Theme-Kopie 233.
   1. teeinblue blendet den Preis- und Kauf-Block des Themes aus und zeigt eigenen Preis und Knopf.
      Steuer-/Versandzeile und Zahlarten werden deshalb direkt unter den teeinblue-Preis bzw. -Knopf gesetzt.
   2. Wartehinweis beim Gestalter: nach dem Foto-Upload sichtbar, bis das Bild in der Druckfläche wechselt (höchstens 45 s).
   3. Warenkorb am Handy: die klebende Leiste weicht, sobald Summe und Knöpfe selbst im Bild sind. */
(() => {
  'use strict';
  if (window.__pmpKaufpfad) return;
  window.__pmpKaufpfad = true;
  const cfg = window.PMP_KAUFPFAD || {};

  const setzen = () => {
    const note = document.querySelector('[data-pmp-price-note]');
    const preis = document.querySelector('.tee-product-price');
    if (note && preis && preis.nextElementSibling !== note) preis.insertAdjacentElement('afterend', note);
    const pay = document.querySelector('[data-pmp-pay]');
    const knopf = document.querySelector('.tee-form-actions');
    if (pay && knopf && knopf.nextElementSibling !== pay) knopf.insertAdjacentElement('afterend', pay);
  };

  let geplant = false;
  const planen = () => { if (geplant) return; geplant = true; requestAnimationFrame(() => { geplant = false; setzen(); }); };

  const form = document.querySelector('[data-product-form]');
  if (form) {
    setzen();
    new MutationObserver(planen).observe(form, { childList: true, subtree: true });
  }

  /* 2. Wartehinweis: nach dem Foto im teeinblue-Gestalter, neu gestartet mit „Speichern“ im Zuschnitt-Dialog.
     Aus, sobald das Bild in der Druckfläche der Galerie wechselt, spätestens nach 45 s. */
  if (form && cfg.warteHinweis && cfg.warteText) {
    let timer = null, poll = null, startSrc = null, bereit = false;
    const baue = (klasse) => {
      const el = document.createElement('p');
      el.className = 'pmp-wait ' + klasse;
      el.setAttribute('role', 'status');
      el.hidden = true;
      el.innerHTML = '<span class="pmp-wait__dot" aria-hidden="true"></span><span></span>';
      el.lastChild.textContent = cfg.warteText;
      return el;
    };
    const imBild = baue('pmp-wait--galerie');
    const amFeld = baue('pmp-wait--feld');
    const druckBild = () => document.querySelector('.tee-printarea img, .tee-printarea--image img');
    const aus = () => { imBild.hidden = true; amFeld.hidden = true; bereit = false; clearTimeout(timer); clearInterval(poll); timer = poll = null; };
    const beobachte = () => {
      const d = druckBild(); startSrc = d ? (d.currentSrc || d.src) : null;
      clearInterval(poll);
      poll = setInterval(() => { const x = druckBild(); const s = x ? (x.currentSrc || x.src) : null; if (s && startSrc && s !== startSrc) aus(); }, 1000);
    };
    const dialogOffen = () => [...document.querySelectorAll('button')].some((k) => k.offsetParent && /^\s*(Speichern|Save)\s*$/i.test(k.textContent || ''));
    const starte = () => {
      const buehne = document.querySelector('.tee-gallery__stage') || document.querySelector('[data-gallery-main]');
      if (buehne && imBild.parentElement !== buehne) {
        if (getComputedStyle(buehne).position === 'static') buehne.style.position = 'relative';
        buehne.appendChild(imBild);
      }
      imBild.hidden = false; amFeld.hidden = false;
      clearTimeout(timer); clearInterval(poll);
      timer = setTimeout(aus, 45000);
    };
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!(t && t.matches && t.matches('input[type=file]') && t.closest('.tee-campaign') && t.files && t.files.length)) return;
      const feld = t.closest('.tee-field, .tee-form-group, .tee-photo-input') || t.parentElement;
      if (feld && amFeld.previousElementSibling !== feld) feld.insertAdjacentElement('afterend', amFeld);
      bereit = true;
      starte();
      /* Ohne Zuschnitt-Dialog beginnt die Berechnung sofort: dann gleich beobachten. */
      setTimeout(() => { if (bereit && !dialogOffen()) beobachte(); }, 2000);
    }, true);
    document.addEventListener('click', (e) => {
      const k = e.target && e.target.closest && e.target.closest('button');
      if (k && bereit && /Speichern|Save/i.test(k.textContent || '')) setTimeout(() => { starte(); setTimeout(beobachte, 800); }, 300);
    }, true);
  }

  /* 3. Warenkorb-Leiste */
  const leiste = document.querySelector('[data-cart-stickybar]');
  const seite = document.querySelector('.cart-page__side');
  if (leiste && seite && 'IntersectionObserver' in window) {
    new IntersectionObserver((eintraege) => {
      eintraege.forEach((e) => leiste.classList.toggle('is-weg', e.isIntersecting));
    }, { threshold: 0.05 }).observe(seite);
  }
})();

/* Fehlerliste 30.09.2026, W3 und P1 (Theme-Kopie v2).
   W3: teeinblue ersetzt beim Laden die Theme-Galerie durch die Kampagnen-Mockups; bei Wandbildern ist Mockup 1 die
       flache Standardvorschau (Beispielhund, Beispielkatze, Beispielpferd) und die Shopify-Bilder mit den Raumszenen sind unsichtbar.
       Jetzt: beim Aufruf zeigt die Galerie die Shopify-Bilder (Bild 1 = Raumszene). Erst wenn der Kunde in DIESER Sitzung
       ein Foto hochgeladen hat UND sein Motiv in der Vorschau gezeichnet ist, erscheint die teeinblue-Galerie, mit dem
       ersten live-fähigen Mockup zuerst (Handyhülle: Mockups 1 bis 4 sind feste Bilder, erst Mockup 5 zeigt das Kundenmotiv).
   P1: Nach dem Upload wird der Stil nicht gerechnet, solange im Feld "Stil" noch "Stil wählen" steht. Ohne Stil bleibt die
       Vorschau auf dem Beispielbild. Deshalb wird nach dem Upload (und geschlossenem Ausschnitt-Dialog) der erste Stil gesetzt.
       Der Kunde kann ihn danach frei wechseln. */
(() => {
  'use strict';
  if (window.__pmpGalerie) return;
  window.__pmpGalerie = true;
  const body = document.body;
  if (!body.classList.contains('template-product') || !document.querySelector('.product__gallery')) return;

  const SHOP = 'pmp-shop-galerie';
  const css = document.createElement('style');
  css.textContent = 
    'body.pmp-shop-galerie .product__gallery .tee-gallery-content{height:0!important;overflow:hidden!important;visibility:hidden!important;margin:0!important;padding:0!important}\n' +
    'body.pmp-shop-galerie .product__gallery>.gallery__main{display:block!important}\n' +
    'body.pmp-shop-galerie .product__gallery>.gallery__thumbs{display:flex!important}\n';
  document.head.appendChild(css);
  body.classList.add(SHOP);

  let hochgeladen = false;
  let gewechselt = false;
  let sucht = false;
  let stilGesetzt = false;

  const wartezeit = ms => new Promise(r => setTimeout(r, ms));
  const dialogOffen = () => [...document.querySelectorAll('button')].some(k => k.offsetParent && /^\s*(Speichern|Save)\s*$/i.test(k.textContent || ''));
  const stilFeld = () => {
    const leer = v => v === '' || v === 'null' || v == null;
    return [...document.querySelectorAll('.tee-form-wrapper select')]
      .find(s => leer(s.value) && [...s.options].some(o => !leer(o.value))) || null;
  };

  /* Kundenmotiv gezeichnet: ein Bild in der Druckvorlage zeigt auf hochgeladene Kundendateien */
  const kundenmotiv = () => [...document.querySelectorAll('svg.tee-mockup-artwork image')]
    .some(im => /\/customers\//.test(im.getAttribute('href') || im.getAttribute('xlink:href') || ''));

  const liveSlide = slide => {
    const pa = slide && slide.querySelector('.tee-printarea--printarea');
    if (!pa) return false;
    const r = pa.getBoundingClientRect();
    return r.width > 4 && r.height > 4;
  };
  const aktiveSlide = () => document.querySelector('.tee-slide--active');

  /* erstes live-fähiges Mockup ansteuern, solange die teeinblue-Galerie noch verborgen ist */
  let liveIdx = -1;
  const zumLivemockup = async () => {
    const daumen = [...document.querySelectorAll('.tee-thumbnails .tee-thumbnail')];
    if (liveSlide(aktiveSlide())) {
      if (liveIdx < 0) liveIdx = daumen.findIndex(d => d.classList.contains('tee-thumbnail--active'));
      return;
    }
    if (liveIdx >= 0 && daumen[liveIdx]) {
      daumen[liveIdx].click();
      await wartezeit(600);
      if (liveSlide(aktiveSlide())) return;
    }
    for (let i = 0; i < daumen.length && i < 10; i++) {
      daumen[i].click();
      await wartezeit(900);
      if (liveSlide(aktiveSlide())) { liveIdx = i; return; }
    }
    if (daumen[0]) daumen[0].click();
  };

  const wechseln = async () => {
    if (sucht || gewechselt) return;
    sucht = true;
    try { await zumLivemockup(); } catch (e) { /* Galerie bleibt wie sie ist */ }
    body.classList.remove(SHOP);
    body.classList.add('pmp-galerie-live');
    gewechselt = true;
    sucht = false;
    const hinweis = () => document.querySelectorAll('.pmp-wait').forEach(e => { e.hidden = true; });
    hinweis();
    setTimeout(hinweis, 1500);
  };

  const stilSetzen = () => {
    if (stilGesetzt || !hochgeladen || dialogOffen()) return;
    const s = stilFeld();
    if (!s) return;
    const erste = [...s.options].find(o => o.value !== '' && o.value !== 'null' && !o.disabled);
    if (!erste) return;
    stilGesetzt = true;
    s.value = erste.value;
    s.dispatchEvent(new Event('input', { bubbles: true }));
    s.dispatchEvent(new Event('change', { bubbles: true }));
  };

  document.addEventListener('change', e => {
    const t = e.target;
    if (!(t && t.matches && t.matches('input[type=file]') && t.closest('.tee-campaign, .tee-form-wrapper') && t.files && t.files.length)) return;
    hochgeladen = true;
    stilGesetzt = false;
  }, true);

  /* S5: Produkte ohne Foto-Upload (Futternapf mit Namen): Die Szenen-Mockups sind feste Bilder mit eingebranntem
     Beispielnamen, nur ein Mockup ist live. Sobald ein Name getippt wird, springt die Galerie auf dieses Mockup. */
  let nameGetippt = false;
  const hatFoto = () => !!document.querySelector('.tee-form-wrapper input[type=file], .tee-campaign input[type=file]');
  document.addEventListener('input', e => {
    const t = e.target;
    if (!(t && t.matches && t.matches('.tee-form-wrapper input[type=text], .tee-campaign input[type=text]'))) return;
    if (t.name === 'honeypot' || hatFoto() || !t.value) return;
    nameGetippt = true;
  }, true);

  /* Das SDK setzt die Galerie bei jeder Namensänderung auf das erste Mockup zurück: nach dem Wechsel das Live-Mockup erneut ansteuern. */
  let nachTimer = null;
  document.addEventListener('input', e => {
    const t = e.target;
    if (!gewechselt || !(t && t.matches && t.matches('.tee-form-wrapper input, .tee-campaign input, .tee-form-wrapper textarea'))) return;
    clearTimeout(nachTimer);
    nachTimer = setTimeout(async () => {
      if (sucht) return;
      sucht = true;
      try { await zumLivemockup(); } catch (err) { /* Galerie bleibt wie sie ist */ }
      sucht = false;
    }, 900);
  }, true);

  setInterval(() => {
    if (!gewechselt && !sucht && nameGetippt) { wechseln(); return; }
    if (!hochgeladen) return;
    stilSetzen();
    if (!gewechselt && !sucht && kundenmotiv()) wechseln();
  }, 500);
})();
